import css from 'styled-jsx/css';

const styles = css.global`.modal-widget {
  display: none;
  pointer-events: none;
  visibility: hidden;
  opacity: 0;
}

.modal-widget.open {
  display: flex;
  pointer-events: unset;
  visibility: visible;
  opacity: 1;
}

.modal-widget .overlay {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  height: 100vh;
  width: 100%;
  overflow: hidden;
  z-index: 9999;
  border: none;
  box-sizing: border-box;
  padding: 0;
  margin: 0;
  background: transparent;

  align-items: center;
  justify-content: center;

  background: #606060;
  background-blend-mode: multiply;
  mix-blend-mode: multiply;
}

.modal-widget .frame {
  background: #fff;
  border: 1px solid #cccccc;
  border-radius: 8px;
  box-shadow: 0px 2px 8px -2px #2222221f;
  background-blend-mode: normal;
  mix-blend-mode: normal;
  position: fixed;
  top: 0;
  right: 0;
  z-index: 10000;

  width: 100%;
  max-width: 416px;
  padding: 16px;
  box-sizing: border-box;
  height: 100%;
}

.modal-widget .content {
  position: relative;
}

.modal-widget .modal-widget-close {
  position: absolute;
  top: -8px;
  right: -8px;
}

.modal-widget.content-fill .content {
  height: 100%;
}
`;

export default styles;